/* Compare up to 4 sprayers on a desktop (min-width 900px) and 3 on a phone. Picks live in localStorage so they follow the painter from the collection to a product page.
   Toggles: [data-compare-toggle][data-compare='{json}'] (delegated, so cards re-rendered by plp.js keep working).
   Data comes from snippets/compare-data.liquid: only published specs, nothing derived.
   Entry links can preload a pair with ?compare=handle-1,handle-2 (see the end of this file). */
(() => {
  const KEY = 'ase.compare.v1';
  const mq = window.matchMedia('(min-width: 900px)');
  const max = () => (mq.matches ? 4 : 3);
  const tray = document.querySelector('[data-compare-tray]');
  const dlg = document.querySelector('[data-compare-dialog]');
  if (!tray) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  let items = read().slice(0, max());
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* private mode: keep in memory */ } };

  const msg = (t) => {
    const el = $('[data-cmp-msg]', tray);
    el.textContent = t;
    clearTimeout(msg.t);
    msg.t = setTimeout(() => { el.textContent = ''; }, 3200);
  };

  function sync() {
    const handles = items.map((i) => i.handle);
    $$('[data-compare-toggle]').forEach((b) => {
      let h = b.dataset.compareHandle;
      if (!h) { try { h = JSON.parse(b.dataset.compare).handle; b.dataset.compareHandle = h; } catch (e) { return; } }
      const on = handles.includes(h);
      b.setAttribute('aria-pressed', String(on));
      const label = b.querySelector('[data-compare-label]');
      if (label) label.textContent = on ? 'In compare' : 'Add to compare';
    });
    tray.hidden = items.length === 0;
    document.documentElement.classList.toggle('has-compare', items.length > 0);
    $('[data-cmp-count]', tray).textContent = items.length;
    $('[data-cmp-open]', tray).disabled = items.length < 2;
    const slots = $('[data-cmp-slots]', tray);
    let html = '';
    for (let i = 0; i < max(); i++) {
      const it = items[i];
      html += it
        ? `<li class="cmp__slot"><span class="cmp__thumb">${it.image ? `<img src="${esc(it.image)}" alt="" width="40" height="40">` : ''}</span><span class="cmp__name">${esc(it.title)}</span><button type="button" class="cmp__x" data-cmp-remove="${esc(it.handle)}" aria-label="Remove ${esc(it.title)}">×</button></li>`
        : '<li class="cmp__slot cmp__slot--empty"><span class="cmp__thumb"></span><span class="cmp__name">Add a sprayer</span></li>';
    }
    slots.innerHTML = html;
    slots.style.gridTemplateColumns = `repeat(${max()}, minmax(0, 1fr))`;
    const mx = $('[data-cmp-max]', tray);
    if (mx) mx.textContent = max();
  }

  function toggle(data) {
    const i = items.findIndex((x) => x.handle === data.handle);
    if (i > -1) { items.splice(i, 1); }
    else if (items.length >= max()) { msg(`You can compare ${max()} at a time. Remove one first.`); return; }
    else { items.push(data); msg(items.length === 1 ? 'Added. Pick one or two more to compare.' : ''); }
    save(); sync();
  }

  const val = (v) => (v == null || v === '' ? '<span class="cmp-na">Not listed</span>' : esc(v));
  const norm = (v) => String(v == null ? '' : v).trim().toLowerCase();

  let notes = null;
  function founderNote(handles) {
    if (notes === null) {
      try { notes = JSON.parse(($('[data-founder-notes]') || {}).textContent || '[]'); } catch (e) { notes = []; }
      if (!Array.isArray(notes)) notes = [];
    }
    const hit = notes.filter((n) => n && n.note && Array.isArray(n.handles) && handles.length && handles.every((h) => n.handles.includes(h)));
    hit.sort((a, b) => a.handles.length - b.handles.length);
    return hit[0] || null;
  }
  // Blank lines start a paragraph; a single line break stays a line break.
  const paras = (t) => String(t).trim().split(/\n\s*\n/).map((p) => `<p>${esc(p.trim()).replace(/\n/g, '<br>')}</p>`).join('');

  // Collapsed bar teaser: the note's first sentence (desktop only, CSS hides it below 990px). Dropped by fitNote when it
  // would need an ellipsis, so the bar only ever shows a whole sentence or none.
  const fnTease = (fn) => {
    const m = String(fn.note || '').trim().match(/^[\s\S]*?[.!?](?=\s|$)/);
    const first = (m ? m[0] : '').replace(/\s+/g, ' ').trim();
    return first && first.length <= 140 ? `<span class="cmp-fn__tease">${esc(first)}</span>` : '';
  };
  // The note block is sticky left inside the sideways scroll, so size it to what is visible rather than to the table.
  function measureNote() {
    const sc = dlg && $('.cmp-scroll', dlg); const t = sc && $('.cmp-table', sc);
    if (t && sc.clientWidth) t.style.setProperty('--fnw', `${sc.clientWidth}px`);
    const tz = dlg && $('.cmp-fn__tease', dlg);
    if (tz && tz.offsetWidth && tz.scrollWidth > tz.offsetWidth + 1) tz.remove();
  }
  function fitNote() {
    // Measured now when the dialog is already open (a re-render), and again a frame later because table() renders before
    // showModal(), when the dialog still measures 0. The open handlers also call measureNote() straight after showModal().
    if (dlg && dlg.open) measureNote();
    requestAnimationFrame(measureNote);
  }
  // One slow light sweep across the founder bar when the compare opens (not on later re-renders; CSS drops it for reduced motion).
  function sweepNote() {
    measureNote();
    const s = dlg && $('.cmp-fn__s', dlg);
    if (s) s.classList.add('is-sweep');
  }
  window.addEventListener('resize', () => { if (dlg && dlg.open) fitNote(); });

  function table() {
    const head = items.map((it) => `<th scope="col"><a href="${esc(it.url)}" class="cmp-col">
        <span class="cmp-col__img">${it.image ? `<img src="${esc(it.image)}" alt="" width="120" height="120" loading="lazy">` : ''}</span>
        <span class="cmp-col__brand">${esc(it.vendor)}</span><span class="cmp-col__title">${esc(it.title)}</span></a></th>`).join('');
    const rows = [
      ['Price inc GST', (it) => it.price],
      ['Max tip', (it) => it.max_tip],
      ['Max pressure', (it) => it.max_pressure],
      ['Max flow', (it) => it.max_flow],
      ['Motor', (it) => it.motor],
      ['Series', (it) => it.series]
    ];
    const skip = /^(max tip size|max working pressure|max pressure|max flow|motor)$/i;
    const labels = [];
    items.forEach((it) => (it.specs || []).forEach((r) => { if (r && r.label && !skip.test(r.label) && !labels.includes(r.label)) labels.push(r.label); }));
    // Pressure rows read psi first, converted from the bar figure (same rule as snippets/pressure-psi.liquid and pdp.js).
    const psiFirst = (v) => {
      if (typeof v !== 'string') return v;
      const m = v.split(' · ')[0].match(/^\s*(\d+(?:\.\d+)?)(?: to (\d+(?:\.\d+)?))? bar\b/);
      if (!m) return v;
      const psi = (b) => { const p = parseFloat(b) * 14.5038; const step = p >= 1000 ? 50 : 10; return Math.round(p / step) * step; };
      // Non-breaking spaces inside each half (as in pressure-psi.liquid): a narrow cell wraps only before the bracket.
      const out = m[2] ? `${psi(m[1])} to ${psi(m[2])} psi (${m[1]} to ${m[2]} bar)` : `${psi(m[1])} psi (${m[1]} bar)`;
      return out.replace(/ /g, '\u00a0').replace('\u00a0(', ' (');
    };
    const isPressure = (l) => /pressure/i.test(l) && !/sound/i.test(l);
    labels.forEach((l) => rows.push([l, (it) => { const r = (it.specs || []).find((x) => x.label === l); return r ? (isPressure(l) ? psiFirst(r.value) : r.value) : null; }]));
    const body = rows.map(([label, get]) => {
      const vals = items.map(get);
      if (vals.every((v) => v == null || v === '')) return '';
      const diff = new Set(vals.map(norm)).size > 1;
      return `<tr class="${diff ? 'is-diff' : 'is-same'}"><th scope="row">${esc(label)}</th>${vals.map((v) => `<td>${val(v)}</td>`).join('')}</tr>`;
    }).join('');
    // Founder note: the active note whose products list holds every sprayer in this comparison, smallest list first
    // (most specific). Notes are printed by snippets/compare-tray.liquid from the founder_note metaobject.
    const fn = founderNote(items.map((it) => it.handle));
    const fnRow = fn ? `<tr class="cmp-fn"><td colspan="${items.length + 1}"><details class="cmp-fn__d">
        <summary class="cmp-fn__s"><span class="cmp-fn__label">A note from the Airless founders</span>${fnTease(fn)}<span class="cmp-fn__ico" aria-hidden="true"></span></summary>
        <div class="cmp-fn__body">${fn.headline ? `<p class="cmp-fn__h">${esc(fn.headline)}</p>` : ''}${paras(fn.note)}<p class="cmp-fn__by">${esc(fn.author || 'Jacob')}</p></div>
      </details></td></tr>` : '';
    const foot = items.map((it) => `<td><a class="btn btn--sm btn--block" href="${esc(it.url)}">View</a></td>`).join('');
    $('[data-cmp-table]', dlg).innerHTML = `<div class="cmp-scroll"><table class="cmp-table" style="--n:${items.length}"><thead><tr><td class="cmp-corner"></td>${head}</tr></thead><tbody>${fnRow}${body}</tbody><tfoot><tr><td></td>${foot}</tr></tfoot></table></div>`;
    fitNote();
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-compare-toggle]');
    if (t) { e.preventDefault(); try { toggle(JSON.parse(t.dataset.compare)); } catch (err) { /* bad payload */ } return; }
    const r = e.target.closest('[data-cmp-remove]');
    if (r) { items = items.filter((x) => x.handle !== r.dataset.cmpRemove); save(); sync(); if (dlg && dlg.open) { if (items.length < 2) dlg.close(); else table(); } return; }
    if (e.target.closest('[data-cmp-clear]')) { items = []; save(); sync(); return; }
    if (e.target.closest('[data-cmp-open]') && dlg) { table(); dlg.showModal(); sweepNote(); document.body.style.overflow = 'hidden'; return; }
    if (e.target.closest('[data-cmp-close]') && dlg) { dlg.close(); }
  });
  if (dlg) {
    dlg.addEventListener('close', () => { document.body.style.overflow = ''; });
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    $('[data-cmp-diff]', dlg).addEventListener('change', (e) => dlg.classList.toggle('is-diff-only', e.target.checked));
  }
  window.addEventListener('storage', (e) => { if (e.key === KEY) { items = read(); sync(); } });
  document.addEventListener('ase:plp-updated', sync);
  const onMq = () => { if (items.length > max()) { items = items.slice(0, max()); save(); } sync(); };
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  sync();

  /* ?compare=handle-1,handle-2: a comparison entry point ("Ultra 490 XT or 495 XT"). Loads those sprayers from the cards
     on this page into compare and opens the table. Handles not on the page are skipped; the parameter is then removed. */
  const params = new URLSearchParams(window.location.search);
  if (params.has('compare')) {
    const want = params.get('compare').split(',').map((h) => h.trim()).filter(Boolean).slice(0, max());
    params.delete('compare');
    history.replaceState(history.state, '', window.location.pathname + (params.toString() ? `?${params}` : '') + window.location.hash);
    const picked = want.map((h) => {
      const b = $$('[data-compare-toggle]').find((x) => { try { return JSON.parse(x.dataset.compare).handle === h; } catch (e) { return false; } });
      try { return b ? JSON.parse(b.dataset.compare) : null; } catch (e) { return null; }
    }).filter(Boolean);
    // Handles not on this page (the list is paged): use the payloads the search compare strip stored just before it linked here.
    if (picked.length < 2) {
      const all = read(); const stored = want.map((h) => all.find((i) => i.handle === h)).filter(Boolean);
      if (stored.length >= 2) picked.splice(0, picked.length, ...stored);
    }
    if (picked.length >= 2) {
      items = picked; save(); sync();
      if (dlg) { table(); dlg.showModal(); sweepNote(); document.body.style.overflow = 'hidden'; }
    }
  }
})();
